export default "__VITE_PUBLIC_ASSET__45d6428d__"